import s from './BottomSection.module.scss';
import AboutMe from '../AboutMe';
import Reviews from '../Reviews';

const BottomSection = () => {
  return (
    <div className={s.root}>
      <AboutMe />
      <Reviews />
    </div>
  )
}

export default BottomSection;
